import React from "react";
import PropTypes from "prop-types";
import Button from "../shared/button/Button";

const CurrentPlanCheckout = (props) => {
  const { buttonName } = props;
  const hhPhoneNumber = "tel:01613007235";
  const buttonClasses =
    "stripe-button-el btn subscription-link payola-subscription-checkout-button";

  return (
    <Button
      primary
      classes={buttonClasses}
      buttonName={buttonName}
      buttonLink={hhPhoneNumber}
      dataTestId="checkout-button"
    />
  );
};

CurrentPlanCheckout.propTypes = {
  buttonName: PropTypes.string.isRequired,
};

export default CurrentPlanCheckout;
